import React from "react";

export default function Navbar(){

    //change each link to just a button that runs its own function and does the following...
    const searchParams = new URLSearchParams(window.location.search);
    const parameterValue = searchParams.get('key1');

    function login(){
        const dataToSend = {key1: parameterValue};
        const queryString = new URLSearchParams(dataToSend).toString();
        const url = `/login?${queryString}`;
        window.location.href = url
    }

    function demo(){
        const dataToSend = {key1: parameterValue};
        const queryString = new URLSearchParams(dataToSend).toString();
        const url = `/demo?${queryString}`;
        window.location.href = url
    }

    function comparison(){
        const dataToSend = {key1: parameterValue};
        const queryString = new URLSearchParams(dataToSend).toString();
        const url = `/comparison?${queryString}`;
        window.location.href = url
    }

    function about(){
        window.location.href = "https://colorantiservices.godaddysites.com/"
    }

    return(
        <nav className="demo-nav">
            <button className="demo-nav-child-2" onClick={about}>ABOUT US</button>
            <button to="/login" className="demo-nav-child-2" onClick={login}>LOGIN/REGISTER</button>
            <button to="/demo" className="demo-nav-child-2" onClick={demo}>DEMONSTRATION</button>
            <button to="/comparison" className="demo-nav-child-2" onClick={comparison}>COMPARISON</button>
        </nav>
    )
}